import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathInfinite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		d: "M10 10c1 2 2.429 3.75 4.5 3.75a3.75 3.75 0 1 0 0-7.5C12.429 6.25 11 8 10 10Zm0 0C9 8 7.571 6.25 5.5 6.25a3.75 3.75 0 1 0 0 7.5C7.571 13.75 9 12 10 10Z"
	})]
});
const ForwardRef = forwardRef(SvgMathInfinite);
export { ForwardRef as ReactComponent };
